import { HolidayMatchBanner } from '@fhs/loyalty/src/components/holiday-match-banner';

import { HomeAlert } from './home-alert';
import type { ScreenHomeProps } from './types';

type SelectHomepageBannerOptions = Partial<
  Pick<ScreenHomeProps, 'alert' | 'userPointExpireAlert'>
> & {
  holidayBannerEnabled: boolean;
};

export function selectHomepageBanner({
  alert,
  userPointExpireAlert,
  holidayBannerEnabled,
}: SelectHomepageBannerOptions) {
  if (alert?.text || userPointExpireAlert?.text) {
    return (
      <>
        {alert?.text && <HomeAlert text={alert.text} link={alert.link} />}
        {userPointExpireAlert?.text && (
          <HomeAlert text={userPointExpireAlert.text} link={userPointExpireAlert.link} />
        )}
      </>
    );
  }

  return holidayBannerEnabled ? <HolidayMatchBanner /> : null;
}
